import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18a27274"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-root" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-language h7 fw6" }, "Languages", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SvgIcon, {
      "icon-name": "logo",
      class: "logo nav-item",
      onClick: $setup.onLogoClicked
    }, null, 8, ["onClick"]),
    _createVNode(_component_SvgIcon, {
      "icon-name": $setup.menuOpen ? 'cross' : 'menu',
      class: "menu nav-item",
      onClick: $setup.onMenuCLicked
    }, null, 8, ["icon-name", "onClick"]),
    _createElementVNode("div", {
      class: "nav-item nav-language",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onLangClicked && $setup.onLangClicked(...args)))
    }, [
      _createVNode(_component_SvgIcon, {
        "icon-name": "language",
        class: "language"
      }),
      _hoisted_2
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["nav-bar", {
      'open': $setup.menuOpen
    }])
    }, [
      _createElementVNode("h2", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onTypeChange(0)))
      }, "VIC"),
      _createElementVNode("h2", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onTypeChange(1)))
      }, "BVIC"),
      _createElementVNode("h2", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.onTypeChange(2)))
      }, "TVIC"),
      ($setup.isLogin)
        ? (_openBlock(), _createElementBlock("h6", {
            key: 0,
            class: "logout",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.onLogout && $setup.onLogout(...args)))
          }, "Log Out"))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}